import { GetBusinessAccountRepresentativeDetailsResp } from 'types/api/response/get-business-account-representative-details-resp'

import { api } from './api'

export const getBusinessAccountRepresentativeDetails = () =>
  api.get<GetBusinessAccountRepresentativeDetailsResp>('/business_accounts_dsa/representatives')
